import React, { useState } from 'react';
import Helmet from 'react-helmet';
import { useHistory } from 'react-router-dom';
import Divider from '@material-ui/core/Divider';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';

import Box from 'retired/Box';

export const DeedVolunteerMatchImport = () => {
  const [url, setUrl] = useState('');
  const history = useHistory();

  const getIdFromUrl = (vmUrl) => vmUrl.substring(url.lastIndexOf('/') + 1).replace(/[^0-9]+/g, '');

  return (
    <Box>
      <Helmet title="Import from VolunteerMatch" />
      <h1>Import from VolunteerMatch</h1>
      <Grid container>
        <Grid item lg={10} md={12}>
          <p>
            Add new opportunities for your Employees through VolunteerMatch. You can{' '}
            <a target="_blank" href="https://www.volunteermatch.org/search">
              browse opportunities
            </a>{' '}
            and when you&apos;re ready to import to deed - just copy and paste the url. Please note
            that you will only be able to modify fields that are specific to your company and the
            listing will be updated by nonprofits through VolunteerMatch.
          </p>
        </Grid>
      </Grid>
      <Divider style={{ marginBottom: 42, marginTop: 24 }} />
      <TextField
        value={url}
        label="VolunteerMatch URL"
        placeholder="VolunteerMatch URL"
        type="text"
        style={{ width: '600px', maxWidth: '100%' }}
        InputLabelProps={{
          shrink: true,
        }}
        onChange={(e) => setUrl(e.target.value)}
      />
      <div style={{ marginTop: 32 }}>
        <Button
          color="primary"
          variant="contained"
          onClick={() => history.push(`/deeds/projects/edit/ext-vm-${getIdFromUrl(url)}`)}
        >
          Import Deed
        </Button>
      </div>
    </Box>
  );
};

export default DeedVolunteerMatchImport;
